export default {"src":"/_next/static/media/NYT.054ef205.svg","height":18,"width":18};